import React, { useState, useEffect } from "react";
import {
  FiSearch,
  FiUser,
  FiBox,
  FiShoppingCart,
  FiMenu,
  FiX,
  FiHeart,
  FiGift,
  FiUserPlus,
  FiLogOut,
  FiLogIn,
  FiHome,
} from "react-icons/fi";
import { Link, useNavigate } from "react-router-dom";
import LoginModal from "./LoginModal";
import Category from "./Category";
import { FaShippingFast } from "react-icons/fa";
import logo from "../assets/img/logo.png";
import { LuLogIn } from "react-icons/lu";
import { BiBasket } from "react-icons/bi";
import MobileFoot from "./MobileFoot";
import SearchBar from "../pages/HomeCompo/SearchBar";
import { useCart } from '../context/CartContext';
import "../assets/css/Topbar.css";
import { TiTicket } from "react-icons/ti";

function Topbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [loginModal, setLoginModal] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const navigate = useNavigate();

  const { cartCount } = useCart();

  // console.log("cartCount", cartCount);

  // 🟢 Check login status
  useEffect(() => {
    const customerId = localStorage.getItem("customerId");
    setIsLoggedIn(!!customerId);
  }, []);

  // Parse user data from localStorage
  const userData = localStorage.getItem("user") ? JSON.parse(localStorage.getItem("user")) : null;
  const displayName = isLoggedIn && userData ? userData.name : "Account";

  // 🟢 Handle Logout
  const handleLogout = () => {
    localStorage.clear();
    setIsLoggedIn(false);
    setMenuOpen(false);
    navigate("/");
    window.location.reload();
  };

  return (
    <>
      <style>{`
        /* Offcanvas Sidebar CSS */
        .mobile-offcanvas {
          position: fixed;
          top: 0;
          left: -100%;
          width: 80%;
          max-width: 300px;
          height: 100%;
          background: #fff;
          z-index: 1050;
          transition: 0.4s ease;
          box-shadow: 2px 0 10px rgba(0,0,0,0.1);
          display: flex;
          flex-direction: column;
        }

        .mobile-offcanvas.active {
          left: 0;
        }

        .offcanvas-overlay {
          position: fixed;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: rgba(0,0,0,0.5);
          z-index: 1040;
          display: none;
        }

        .offcanvas-overlay.active {
          display: block;
        }

        .offcanvas-header {
          padding: 20px;
          background: #f8f9fa;
          display: flex;
          justify-content: space-between;
          align-items: center;
          border-bottom: 1px solid #eee;
        }

        .offcanvas-user-info {
          display: flex;
          align-items: center;
          gap: 10px;
          font-weight: 600;
        }

        .offcanvas-body {
          padding: 10px 0;
          overflow-y: auto;
        }

        .offcanvas-link {
          display: flex;
          align-items: center;
          gap: 15px;
          padding: 12px 20px;
          color: #333;
          text-decoration: none;
          font-size: 15px;
          transition: 0.2s;
        }

        .offcanvas-link:active {
          background: #f1f1f1;
        }

        /* Mobile Header Adjustments */
        .mobile-only-header {
          display: none;
          padding: 10px 15px;
          background: #fff;
          border-bottom: 1px solid #eee;
          position: sticky;
          top: 0;
          z-index: 1000;
        }

        @media (max-width: 991px) {
          .desktop-only { display: none; }
          .mobile-only-header { display: block; }
        }

        .mobile-top-bar {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 8px;
        }

        .mobile-left, .mobile-right {
          display: flex;
          align-items: center;
          gap: 15px;
        }

        .mobile-logo-img {
          height: 30px;
        }
      `}</style>

      {/* 🖥️ Desktop Header */}
      <header className="custom-navbar desktop-only">
        <div className="custom-navbar-container">
          <Link to="/" className="custom-logo">
            <img src={logo} className="img-fluid logo" alt="logo" />
          </Link>

          <SearchBar />

          <nav className="custom-nav-links">
            <Link to="/seller" className="btn btn-primary text-white">Become a Seller</Link>
           
           
           
            <Link to="/cart" className="custom-cart-btn"><FiShoppingCart size={18} /> Cart {cartCount > 0 && (
          <span className="deskcart">
            {cartCount}
          </span>
        )}   </Link>


            <Link to="/wishlist" className="custom-cart-btn"><FiHeart size={18} /> Wishlist</Link>

            <div className="custom-dropdown">
              <button className="custom-dropbtn">
                <FiUser size={18} /> {displayName}
              </button>
              <div className="custom-dropdown-content">
                {isLoggedIn ? (
                  <>
                    <div style={{ padding: "12px 16px", borderBottom: "1px solid #f1f1f1", fontWeight: "600" }}>
                      Hello, {userData?.name.split(' ')[0]}!
                    </div>
                    <Link to="/profile"><FiUser size={16} /> My Profile</Link>
                    <Link to="/orders"><FiBox size={16} /> Orders</Link>
                    <Link to="/wishlist"><FiHeart size={16} /> Wishlist</Link>
                    <Link to="/ship-address"><FaShippingFast size={16} /> Shipping</Link>
                    <Link to="/coupons"><TiTicket size={16} /> Coupons & Offers</Link>
                    <a onClick={handleLogout} style={{ cursor: "pointer", color: "#e74c3c" }}><FiLogOut size={16} /> Logout</a>
                  </>
                ) : (
                  <>
                    <a onClick={() => setLoginModal(true)} style={{ cursor: "pointer" }}><FiLogIn size={16} /> Login</a>
                    <a onClick={() => setLoginModal(true)} style={{ cursor: "pointer" }}><FiUserPlus size={16} /> Sign Up</a>
                  </>
                )}
              </div>
            </div>
          </nav>
        </div>
      </header>

      {/* 📱 Mobile Header (Myntra Style) */}
      <header className="mobile-only-header">
        <div className="mobile-top-bar">
          <div className="mobile-left">
            <FiMenu size={24} onClick={() => setMenuOpen(true)} />
            <Link to="/">
              <img src={logo} className="mobile-logo-img" alt="logo" />
            </Link>
          </div>
          <div className="mobile-right">
            <Link to="/wishlist" className="text-dark"><FiHeart size={22} /></Link>
            <Link to="/cart" className="text-dark"><BiBasket size={24} /></Link>
          </div>
        </div>
        <SearchBar />
      </header>

      {/* 📱 Mobile Offcanvas Sidebar */}
      <div className={`offcanvas-overlay ${menuOpen ? "active" : ""}`} onClick={() => setMenuOpen(false)}></div>
      <div className={`mobile-offcanvas ${menuOpen ? "active" : ""}`}>
        <div className="offcanvas-header">
          <div className="offcanvas-user-info">
            <FiUser size={20} />
            <span>{isLoggedIn ? `Hello, ${userData?.name.split(' ')[0]}` : "Welcome"}</span>
          </div>
          <FiX size={24} onClick={() => setMenuOpen(false)} />
        </div>

        <div className="offcanvas-body">
          <Link to="/" className="offcanvas-link" onClick={() => setMenuOpen(false)}>
            <FiHome /> Home
          </Link>
          <Link to="/orders" className="offcanvas-link" onClick={() => setMenuOpen(false)}>
            <FiBox /> My Orders
          </Link>
          <Link to="/wishlist" className="offcanvas-link" onClick={() => setMenuOpen(false)}>
            <FiHeart /> Wishlist
          </Link>
          <Link to="/cart" className="offcanvas-link" onClick={() => setMenuOpen(false)}>
            <FiShoppingCart /> My Cart
          </Link>
          <Link to="/seller" className="offcanvas-link" onClick={() => setMenuOpen(false)}>
            <FiGift /> Become a Seller
          </Link>
          <hr />
          {isLoggedIn ? (
            <a className="offcanvas-link" onClick={handleLogout} style={{ color: "#e74c3c" }}>
              <FiLogOut /> Logout
            </a>
          ) : (
            <a className="offcanvas-link" onClick={() => { setLoginModal(true); setMenuOpen(false); }}>
              <FiLogIn /> Login / Sign Up
            </a>
          )}
        </div>
      </div>

      <MobileFoot />
      <LoginModal show={loginModal} onClose={() => setLoginModal(false)} />
    </>
  );
}

export default Topbar;